export const accountTypes = {
    JURIDICAL: 'JURIDICAL',
    PHYSICAL: 'PHYSICAL'
};

export const personalCodeTypes = {
    NIE: 'NIE',
    DNI: 'DNI'
};
